<template>
    <div class="feedback__items">
        <div class="feedback__item feedback__item_comment">
            <div class="feedback__i-info">
                <img :src='comment.author.avatar' alt="#" class="avatar feedback__i-avatar">
                <div class="feedback__i-inner">
                    <span class="feedback__i-name">{{comment.author.name}}</span>
                    <time class="feedback__i-time">{{convertDate(comment.created_at)}}</time>
                </div>
            </div>
            <div class="feedback__i-text">
                <p>
                    {{comment.description}}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import dayjs from "dayjs";

    export default {
        name: "Comment",
        props: {
            comment: {
                type: Object,
                required: true
            }
        },
        computed: {
            timezone() {
                return window.laravel.userTimeZone ? window.laravel.userTimeZone : Intl.DateTimeFormat().resolvedOptions().timeZone;
            }
        },
        methods: {
            convertDate(date) {
                return dayjs.createFromTimezone(date, this.timezone).format('DD.MM.YYYY HH:mm');
            }
        }
    }
</script>
